import { useState } from 'react';
import { toast } from 'sonner';
import { ExportService } from '@/services/import/ExportService';

export function useOptimizedExport() {
  const [isExporting, setIsExporting] = useState(false);

  const exportOptimizedData = async (
    providerId: number, 
    versionId: number, 
    providerName: string, 
    versionNumber: string
  ) => {
    try {
      setIsExporting(true);
      
      const exportData = await ExportService.exportOptimizedProviderData(providerId, versionId);
      
      const filename = ExportService.generateFilename(
        providerName,
        versionNumber,
        exportData.context.export_timestamp,
        'optimized'
      );
      
      ExportService.downloadJSON(exportData, filename);

      toast.success(`Data exported successfully with ${exportData.summary.space_optimization.reduction_percentage} size reduction`);
    } catch (error) {
      console.error('Optimized export failed:', error);
      toast.error("An error occurred while exporting the optimized data. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportOptimizedData,
    isExporting,
  };
}